const webTab =  {
    LOAD_WEB_TAB: "LOAD_WEB_TAB",
    LOADED_WEB_TAB: "LOADED_WEB_TAB",
    ERROR_LOADING_WEB_TAB: "ERROR_LOADING_WEB_TAB"
};

export default webTab;